import React from 'react';
import './style.scss';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import clsx from 'clsx';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';

const Content = (props) => {
  if (!props?.fields || !props.params) {
    return <GenericPlaceholder componentName="Content" />;
  }
  const isEliteTheme = props?.fields?.IsEliteTheme?.value;

  return (
    <div
      className={clsx(
        'content',
        'content-component',
        isEliteTheme ? 'theme-elite' : 'theme-default',
        'add-margins',
        props?.params?.Styles
      )}
    >
      <RichText className="description" field={props?.fields.content} />
    </div>
  );
};

export default Content;
